<section class="onboard_screen">
    <div class="logo_div">
        <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Header/logo.png" class="logo">
    </div>
    <div class="hand_div">
        <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Login/hand_img.svg" class="img-fluid"
            style="position: relative;">
        <p class="onboard_text">Get ready to embark on a journey of learning,<br /> growth, and success</p>
    </div>
    <h1 class="onboard_heading">GODFATHER <span>of accountants</span></h1>
    <div class="animated_btn_div" (mouseenter)="showImage = true" (mouseleave)="showImage = false">
        <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Login/bottom_arrow.svg"
            class="bottom_arrow">
        <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Login/white_arrow.svg" class="bottom_arrow_mobile">    
        <div id="lottieContainer" class="animated_btn" [style.display]="showImage ? 'none' : 'inherit'"
            [routerLink]="'/game-plan-status-page'"></div>
        <img *ngIf="showImage"
            src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Login/startAnimationButton.svg"
            class="start_btn" alt="Image Button" (click)="start()" />
        <!-- [routerLink]="'/game-plan-status-page'" -->
    </div>
</section>